import { Column, CreateDateColumn, Entity,UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";


@Entity('trims')
export class Trims {

    @PrimaryGeneratedColumn("increment",{name:'trimsid'})
    
    trimsId:number;

    @Column("char",{
        nullable:false,
        length:30,
        name:"trim_name"
    })
    trimName:string;

    

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

   

    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar",{
        nullable : true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
  createdAt: Date;
}